<fs-alpr-hit-details-card
  *ngIf="isAlprAlarm(); else alarmCard"
  [hideActions]="data.hideActions"
  [alarm]="data.alarm"
  (sendToEvent)="openSendDialog($event)"
  class="alpr-card"
></fs-alpr-hit-details-card>

<ng-template #alarmCard>
  <sn-alarm-card
    [alarm]="data.alarm"
    [hideActions]="data.hideActions"
    class="default-card"
  ></sn-alarm-card>
</ng-template>
